module.exports = __webpack_public_path__ + "img/img4.23ec11e0.jpg";